export default {
  alarm: {
    name: '告警管理',
    prop: {
      title: '标题',
      description: '描述',
      created_at: '首次触发时间',
      updated_at: '更新时间',
      alarm_category_level: '告警等级',
      resolved: '解除状态',
      charge_station: '告警电站',
      alarm_object_type: '告警对象类型',
      trigger_source: '告警来源',
      resolved_type: '解除方式',
      completed_time: '完成时间',
      service_provider: '运营商',
      suggestion: '建议',
      charger: '告警电桩',
      work_order_status: '工单状态',
      assignee: '指派人',
      warranty: '桩保情况',
      alarm_object: '告警对象',
      resolved_at: '解除时间',
      level: '告警等级',
      trigger_count: '触发次数',
      last_trigger_at: '最后触发时间',
      uncompleted_work_order: '是否有未完成的工单',
      duration: '持续时间',
      has_work_order: '是否有工单'
    },
    list_tabs: {
      all: '全部',
      unresolved: '未解除',
      resolved: '已解除'
    },
    labels: {
      unresolved_error_alarms_count: '未解除故障告警数',
      resolved_error_alarms_count: '已解除故障告警数',
      error_alarms_count_with_work_order: '有工单的故障告警数',
      error_alarms_count_without_work_order: '无工单的故障告警数'
    },
    placeholder: {
      search_keyword: '标题/维修工单号/指派者',
      alarm_object_type: '请选择告警对象',
      trigger_source: '请选择告警来源',
      resolved_type: '请选择解除方式'
    },
    alarm_object_types: {
      charge_station: '充电站',
      charger: '充电桩'
    },
    has_work_orders: {
      true: '有',
      false: '无'
    },
    tips: {
      unresolved: '最近一年触发的未解除告警'
    },
    trigger_sources: {
      agent: '来源设备',
      platform: '来源平台'
    },
    resolved_types: {
      auto_resolved: '自动解除',
      manual_resolved: '手动解除'
    },
    uncompleted_work_orders: {
      true: '是',
      false: '否'
    },
    titles: {
      base_info: '基本信息',
      charger_info: '告警电桩信息',
      work_order: '工单信息',
      picture_info: '图片信息'
    },
    resolveds: {
      true: '已解除',
      false: '未解除'
    },
    btn: {
      mark_selected: '标记为已解除',
      alarm_whitelists: '白名单'
    },
    toast: {
      not_selected: '没有选中记录'
    },
    resolved: '是否已处理',
    levels: {
      warning: '警告',
      info: '提示',
      error: '故障'
    },
    work_order_statuses: {
      missing: '无工单',
      assigned: '已指派',
      processing: '处理中',
      resolved: '已处理',
      closed: '已关闭'
    }
  }
}
